import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { LoonAction } from "../interfaces/loon-action";
import { SubType } from "../types";

@Injectable({
	providedIn: "root",
})
export class SharedService {
	constructor(private router: Router) {}

	navigateToListing(listingID: number | string): void {
		this.router.navigate(["/", "listing", listingID]);
	}

	navigateToEditListing(listingID: number | string): void {
		this.router.navigate(["/", "listing", listingID, LoonAction.EDIT]);
	}

	classIconUrl(classCode?: string): string {
		const urls = {
			SF: "assets/images/svg/Single_Family.svg",
			MF: "assets/images/svg/Multi_Family.svg",
			RR: "assets/images/svg/Residential_Rentals.svg",
			LL: "assets/images/svg/LotsAndLand.svg",
			LLRLIT: "assets/images/svg/LotsAndLand.svg",
			CMU: "assets/images/svg/Commercial.svg",
			FRM: "assets/images/svg/Farm.svg",
			FRMRLIT: "assets/images/svg/Farm.svg",
		};
		return urls[classCode];
	}
}

export function sortByNumberProp<T extends SubType<T, number>>(property: keyof SubType<T, number>) {
	return (a: T, b: T) => a[property] - b[property];
}
